import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, inject, effect } from "@angular/core";
import { PageEvent, MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { Observable, Subject } from "rxjs";
import { PurchaseComponent } from "../../stripe/purchase/purchase.component";
import { MatMenuModule } from "@angular/material/menu";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { RouterLink } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { ScreenStore } from "../../stores/index";
import { AgGridAngular } from "ag-grid-angular"; // Angular Data Grid Component
import { CellClickedEvent, ColDef, GridOptions, RowClassParams } from "ag-grid-community";

export interface JhmTableRepository
{
	fetchAll: () => Observable<any[]>;
	ready: Observable<boolean>;
	colDefs: ColDef[];
    rowClassFunction?: ((params: RowClassParams<any>) => string | string[] | undefined) | undefined;
}

@Component({
	selector: "jhm-table",
	templateUrl: "./jhm-table.component.html",
	styleUrls: ["./jhm-table.component.scss"],
	standalone: true,
	host: {
		"[class.mobile]": "isMobile"
	},
	imports: [
		MatFormFieldModule,
		MatInputModule,
		FormsModule,
		RouterLink,
		MatTableModule,
		MatSortModule,
		MatCheckboxModule,
		MatMenuModule,
		MatPaginatorModule,
		PurchaseComponent,
		AgGridAngular
	]
})
export class JhmTableComponent implements OnDestroy, OnInit
{
	@Input() public zeroState: string;
	@Input() public repository: JhmTableRepository;
	@Input() public refreshTableData: Subject<boolean>;
	@Input() public showHeaders: boolean = true;
	@Input() public initialPageEvent: PageEvent;
	@Input() public portalName: string;
	@Input() public colDefs: ColDef[] = [];
	@Output() public cellClicked: EventEmitter<CellClickedEvent> = new EventEmitter<CellClickedEvent>();
	@Output() public currentTableData: EventEmitter<any[]> = new EventEmitter<any[]>();
	@Output() public pageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
	@Output() public zeroStateActionClick: EventEmitter<void> = new EventEmitter<void>();

	public searchQuery: string = "";
	public showStripeModal: boolean = false;
	private repositoryIsReady: boolean = false;
	public screenSize: string;
	public isMobile: boolean = false;
	public ngDestroyed$: Subject<any> = new Subject();
	readonly screenStore = inject(ScreenStore);
	public rowData: any[] = [];
	public gridOptions: GridOptions;
	public loading: boolean = true;
	public length: number;
	// public gridApi: GridApi;

	public constructor()
	{
		effect(() => {
			this.screenSize = this.screenStore.screenSize();
			if (this.screenSize === "MOBILE") {
				this.isMobile = true;
			}
			else {
				this.isMobile = false;
			}
		})
	}

	public ngOnInit(): void
	{
		this.repository.ready.subscribe((isReady: boolean)=>
		{
			this.repositoryIsReady = isReady;
			if (isReady)
			{
				this.fetchAllData();
			}
			if (this.refreshTableData)
			{
				this.refreshTableData.subscribe(() =>
				{
					this.updateData();
				});
			}
		});
	}

	ngOnDestroy(): void
	{
		this.ngDestroyed$.next(true);
	}

	public clickedCell(row: any): void
	{
		this.cellClicked.emit(row);
	}

	private updateData(): void
	{
		if (this.repositoryIsReady)
		{
			this.fetchAllData();
		}
	}

	private fetchAllData(): void {
		this.loading = true;
		this.repository.fetchAll().subscribe((rows: any[]) =>
		{
			this.rowData = rows;
			this.currentTableData.emit(rows);
			this.length = rows.length;
			this.loading = false;
		});
	}
}
